// extracted by mini-css-extract-plugin
module.exports = {"wrap":"btn-link_wrap__VYVUn","btnLink":"btn-link_btnLink__hkguq","text":"btn-link_text__e6X8B"};